import { cn } from '../../lib/utils';
import { Text } from '../Text/Text';

type HeadingRange = 1 | 2 | 3 | 4 | 5;

// Styles based on https://www.figma.com/design/D0EpstolZg8PSBL4rAd1YA/Altify--%3E-Style-Guide?node-id=140-407
const levelClasses = [
  'font-semibold text-6xl',
  'font-semibold text-5xl',
  'font-semibold text-4xl',
  'font-semibold text-3xl',
  'font-semibold text-2xl',
];

export function Heading({
  level,
  className,
  as,
  children,
}: {
  level: HeadingRange;
  className?: string;
  as?: React.ElementType;
  children: React.ReactNode;
}) {
  const levelClass = levelClasses[level - 1];
  const tag = as ?? `h${level}`;

  return (
    <Text as={tag} className={cn(levelClass, className)}>
      {children}
    </Text>
  );
}
